import {AnyAction} from 'redux'
import {crudReducer, CrudState, initialCrudState} from 'lib/crud'

export const name = 'CLASS_DURATION'

export type ClassDurationState = {
    crud: CrudState,
}

const initialState = {
    crud: initialCrudState,
}

export function classDurationReducer(state: ClassDurationState = initialState, action: AnyAction): ClassDurationState {
    switch (action.type) {
        default:
            return {
                ...state,
                crud: crudReducer(name, state.crud, action)
            }
    }
}
